import { CSSProperties } from 'react';
import { FelaCSS, colors } from '@bridebook/ui';

interface IStyles {
  wrapper: FelaCSS;
  minifiedWrap: FelaCSS;
  shrunkTextWrap: FelaCSS;
  responseContainer: FelaCSS;
  responseWrapper: FelaCSS;
  venueResponse: FelaCSS;
  buttonContainer: FelaCSS;
  buttonWrapper: FelaCSS;
  venueRespondedMark: FelaCSS;
  responseText: FelaCSS;
  shortResponse: FelaCSS;
  approveIcon: CSSProperties;
  buttonStyles: FelaCSS;
  expandOrCollapseButtonWrapper: FelaCSS;
  expandOrCollapseButton: FelaCSS;
}

const styles = (hasExpandOrCollapseButton?: boolean): IStyles => ({
  wrapper: {
    margin: '12px 0',
    fontDefault: 14,
    lineHeight: '20px',
    color: colors.space,
  },

  minifiedWrap: {
    alignItems: 'flex-start',
  },

  shrunkTextWrap: {
    marginBottom: '16px',
    overflowWrap: 'break-word',
    width: '100%',
  },
  responseContainer: {
    marginTop: 2,
    marginBottom: 2,
    borderLeft: `1px solid ${colors.space40}`,
    width: '100%',
  },
  responseWrapper: {
    paddingLeft: 6,
    paddingTop: 2,
    paddingBottom: 2,
  },
  responseText: {
    overflowWrap: 'break-word',
  },
  venueResponse: {
    flexDirection: 'row',
    color: colors.space,
    fontDefaultSemiBold: 14,
    marginBottom: 2,
  },
  buttonContainer: {
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  buttonWrapper: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  buttonStyles: {
    textAlign: 'left',
    marginRight: 1,
    whiteSpace: 'nowrap',
  },
  venueRespondedMark: {
    flexDirection: 'row',
    color: colors.space75,
    fontDefaultSemiBold: 14,
    whiteSpace: 'nowrap',
  },
  shortResponse: {
    width: '100%',
    justifyContent: 'flex-end',
    flexDirection: 'row',
    color: colors.space75,
    fontDefaultSemiBold: 14,
  },
  approveIcon: {
    color: colors.mint,
    marginLeft: 4,
  },
  expandOrCollapseButtonWrapper: {
    marginTop: 2,
    display: hasExpandOrCollapseButton ? 'flex' : 'none',
  },
  expandOrCollapseButton: {
    textDecoration: 'underline',
  },
});

export default styles;
